import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-757dac4b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "common-title" }
const _hoisted_2 = {
  key: 0,
  class: "tag-list"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 1 }

import { ref, computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'common-title-template',
  props: {
    title: {
        type: String,
        default: '',
    },
    showMore: {
        type: Boolean,
        default: true,
    },
    tagList: {
        type: Array,
        default: () => {
            return [];
        },
    },
    titleColor: {
        type: String,
        default: '#2164C9',
    },
    tagColor: {
        type: String,
        default: '#000',
    },
    moreColor: {
        type: String,
        default: '#2164C9',
    },
    hoverColor: {
        type: String,
        default: '#2164C9',
    },
    defaultTag: {
        type: [String, Number],
    },
    tagConfig: {
        type: Object,
        default: () => ({}),
    },
},
  emits: ['goMore', 'changeTag'],
  setup(__props, { emit }) {

const props = __props;





const curTag = ref(props.defaultTag ?? []);

const getStyle = computed(() => {
    return `
        --title-color: ${props.titleColor};
        --tag-color: ${props.tagColor};
        --more-color: ${props.moreColor};
        --hover-color: ${props.hoverColor};
    `;
});

const realList = computed(() => {
    return props.tagList.filter(item => item.checked);
});

const goMore = () => {
    emit('goMore');
};

const changeTag = (tag = []) => {
    curTag.value = curTag.value === tag ? [] : tag;
    emit('changeTag', curTag.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "common-title-box",
    style: _normalizeStyle(_unref(getStyle))
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(__props.title), 1),
    (__props.tagConfig?.show ?? true)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(realList), (item) => {
            return (_openBlock(), _createElementBlock("li", {
              class: _normalizeClass([{ active: curTag.value === item.value }]),
              key: item.tagKey,
              onClick: ($event: any) => (changeTag(item.value))
            }, _toDisplayString(item.tagName), 11, _hoisted_3))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default"),
    (props.showMore)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("a", {
            class: "more",
            onClick: goMore,
            href: "javascript:;"
          }, "更多 >")
        ]))
      : _createCommentVNode("", true)
  ], 4))
}
}

})